import React, { useState, useEffect } from 'react';
import { Avatar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import config from '../../../config/config.json';

const useStyles = makeStyles((theme) => ({
    root: {
        height: 180,
    },
    wrapper: {
        width: 100 + theme.spacing(2),
    },
    paper: {
        zIndex: 1,
        position: 'relative',
        margin: theme.spacing(1),
        padding: theme.spacing(5)
    },
    svg: {
        width: 100,
        height: 100,
    },
    polygon: {
        fill: theme.palette.common.white,
        stroke: theme.palette.divider,
        strokeWidth: 1,
    },
}));

export default function NewsRightSideBar({ }) {
    const classes = useStyles();
    const [noticiasRecientes, setNoticiasRecientes] = useState([]);
    const [categorias, setCategorias] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 1);
    }, []);

    useEffect(() => {
        let url = `${config.apiBaseUrl}/noticias`;

        // obteniendo las noticias
        fetch(url)
            .then(
                res => {
                    return res.json();
                }
            )
            .then(
                data => {
                    console.log('noticias recientes => ', data.slice(0, 3));
                    setNoticiasRecientes(data.slice(0, 3));
                }
            )
            .catch(
                err => {
                    console.log("news error ", err);
                }
            );

        // obteniendo categorias de noticias
        url = `${config.apiBaseUrl}/categorias`;
        fetch(url)
            .then(
                res => {
                    return res.json();
                }
            )
            .then(
                data => {
                    console.log('categorias => ', data);
                    setCategorias(data);
                }
            )
            .catch(
                err => {
                    console.log('category error: ', err);
                }
            );

        // cleanup
        return () => {
        }
    }, []);

    // categorias
    const CategoriasComponent = Object.values(categorias).map((categoria, index) => (
        <React.Fragment key={index}>
            <li /* className="active" */>
                <Link to={"/news/category/" + categoria.slug}>{categoria.categoria} ({categoria.cantidad_noticias})</Link>
            </li>
        </React.Fragment>
    ));

    const getIniciales = (autor) => {
        const autorArr = autor.split(' ');

        const n = autorArr[0][0].toLowerCase();
        let n1, ap1, ap2;
        if (autorArr.length == 3) {
            n1 = '';
            ap1 = autorArr[1][0].toLowerCase();
            ap2 = autorArr[2][0].toLowerCase();
        } else if (autorArr.length == 4) {
            n1 = autorArr[1][0].toLowerCase();
            ap1 = autorArr[2][0].toLowerCase();
            ap2 = autorArr[3][0].toLowerCase();
        }

        return n + n1 + ap1 + ap2;
    }
    // noticias recientes 
    let RecientesComponent = [];
    for (const i in noticiasRecientes) {
        RecientesComponent[i] =
            <div className="row margin-bottom-10" key={i}>
                <div className="col-md-3">
                    <Avatar alt={noticiasRecientes[i].autor} src={`./assets/files/avatar/all_trab/${getIniciales(noticiasRecientes[i].autor)}.png`} className={classes.xl} />
                </div>
                <div className="col-md-9 recent-news-inner">
                    <h3><Link to={"/new/" + noticiasRecientes[i].nombre}>{noticiasRecientes[i].titulo}</Link></h3>
                    <p>{noticiasRecientes[i].texto.substring(0, 51)}...</p>
                </div>
            </div>
    }

    return (
        <React.Fragment>
            {/* BEGIN RIGHT SIDEBAR */}
            < div className="col-md-3 col-sm-3 blog-sidebar" >
                {/* CATEGORIES START */}
                < h2 className="no-top-space" > Categorías</h2 >
                <ul className="nav sidebar-categories margin-bottom-40">

                    {CategoriasComponent}

                </ul>
                {/* CATEGORIES END */}

                {/* BEGIN RECENT NEWS */}
                <h2>Noticias Recientes</h2>
                <div className="recent-news margin-bottom-10">

                    {RecientesComponent}

                </div>
                {/* END RECENT NEWS */}

                {/* BEGIN BLOG TALKS */}
                {/* <div className="blog-talks margin-bottom-30">
                                    <h2>Popular Talks</h2>
                                    <div className="tab-style-1">
                                        <ul className="nav nav-tabs">
                                            <li className="active"><a data-toggle="tab" href="#tab-1">Multipurpose</a></li>
                                            <li><a data-toggle="tab" href="#tab-2">Documented</a></li>
                                        </ul>
                                        <div className="tab-content">
                                            <div id="tab-1" className="tab-pane row-fluid fade in active">
                                                <p className="margin-bottom-10">Raw denim you probably haven't heard of them jean shorts Austin. eu banh mi, qui irure terry richardson ex squid Aliquip placeat salvia cillum iphone.</p>
                                                <p><a className="more" href="#">Read more</a></p>
                                            </div>
                                            <div id="tab-2" className="tab-pane fade">
                                                <p>Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid. aliquip jean shorts ullamco ad vinyl aesthetic magna delectus mollit. Keytar helvetica VHS salvia..</p>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                {/* END BLOG TALKS */}

                {/* BEGIN BLOG PHOTOS STREAM */}
                {/* <div className="blog-photo-stream margin-bottom-20">
                                    <h2>Photos Stream</h2>
                                    <ul className="list-unstyled">
                                        <li><a href="#"><img alt="" src="assets/frontend/pages/img/people/img5-small.jpg" /></a></li>
                                        <li><a href="#"><img alt="" src="assets/frontend/pages/img/works/img1.jpg" /></a></li>
                                        <li><a href="#"><img alt="" src="assets/frontend/pages/img/people/img4-large.jpg" /></a></li>
                                        <li><a href="#"><img alt="" src="assets/frontend/pages/img/works/img6.jpg" /></a></li>
                                        <li><a href="#"><img alt="" src="assets/frontend/pages/img/pics/img1-large.jpg" /></a></li>
                                        <li><a href="#"><img alt="" src="assets/frontend/pages/img/pics/img2-large.jpg" /></a></li>
                                        <li><a href="#"><img alt="" src="assets/frontend/pages/img/works/img3.jpg" /></a></li>
                                        <li><a href="#"><img alt="" src="assets/frontend/pages/img/people/img2-large.jpg" /></a></li>
                                    </ul>
                                </div> */}
                {/* END BLOG PHOTOS STREAM */}

                {/* BEGIN BLOG TAGS */}
                {/* <div className="blog-tags margin-bottom-20">
                                    <h2>Etiquetas</h2>
                                    <ul>
                                        <li><a href="#"><i className="fa fa-tags"></i>OS</a></li>
                                        <li><a href="#"><i className="fa fa-tags"></i>Metronic</a></li>
                                        <li><a href="#"><i className="fa fa-tags"></i>Dell</a></li>
                                        <li><a href="#"><i className="fa fa-tags"></i>Conquer</a></li>
                                        <li><a href="#"><i className="fa fa-tags"></i>MS</a></li>
                                        <li><a href="#"><i className="fa fa-tags"></i>Google</a></li>
                                        <li><a href="#"><i className="fa fa-tags"></i>Keenthemes</a></li>
                                        <li><a href="#"><i className="fa fa-tags"></i>Twitter</a></li>
                                    </ul>
                                </div> */}
                {/* END BLOG TAGS */}

            </div >
            {/* END RIGHT SIDEBAR */}
        </React.Fragment>
    );
}